import React, { forwardRef } from 'react';
import clsx from '@strava/ui/clsx';
import { useFrontDoorsPageContainerContext } from '../../state/FrontDoorsPageContainerContext';
import DesktopNav from './components/DesktopNav';
import MobileNav from './components/MobileNav';

import styles from './Header.module.scss';

const Header = forwardRef((_, ref) => {
  const { state } = useFrontDoorsPageContainerContext();

  const isScrolling = state.windowScrollTop > 0;

  return (
    <div
      className={clsx(styles.container, isScrolling && styles.isScrolling)}
      ref={ref}
    >
      <nav className={styles.menu}>
        <div className={styles.items}>
          {/* desktop  */}
          <DesktopNav />

          {/* mobile */}
          <MobileNav />
        </div>
      </nav>
    </div>
  );
});

export default Header;
